module.exports = __webpack_public_path__ + "img/addicongraywhite.73f7da44.svg";